<template>
  <v-flex>
    <v-skeleton-loader
      :loading="loading"
      height="320"
      transition="scale-transition"
      type="image"
    >
      <apexchart
        :options="chartOptions"
        :series="series"
        height="320"
        type="radar"
      />
    </v-skeleton-loader>
  </v-flex>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import DashService from "@/services/dashboard.service";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    title: String,
    subTitle: String,
    icon: String,
    cardColor: {
      type: String,
      default: "white",
    },
    iconColor: {
      type: String,
      default: "success",
    },
    courseId: Number,
    mockLogId: Number,
  },
  created() {
    const _this = this;
    console.log(this.courseId, this.mockLogId);
    DashService.getPerformanceByTopics(this.courseId, this.mockLogId).then(
      (res) => {
        // console.log(res.data.map(a => a.topic))
        let labels;
        labels = _this.prepareLabels(res.data);
        this.chartOptions.xaxis.categories = labels;
        this.chartOptions.labels = labels;
        this.series[0].data = res.data.map((a) => a.percent);
        console.log(res.data, this.series[0].data);
        // this.series[0].labels = labels
        this.loading = false;
      },
    );
  },
  data() {
    return {
      loading: true,
      chartOptions: {
        labels: null,
        title: {
          text: "",
        },
        plotOptions: {
          radar: {
            size: 100,
            polygons: {
              strokeColor: "#e9e9e9",
              fill: {
                colors: ["#fff", "#fff"],
              },
            },
            offsetX: 5,
            offsetY: 5,
          },
        },
        yaxis: {
          show: false,
          min: 0,
          max: 100,
          tickAmount: 5,
          labels: {
            formatter: function (val) {
              return val + "%";
            },
          },
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: true,
            minHeight: 80,
            maxHeight: 10,
            style: {
              colors: [],
              fontSize: "10px",
              fontFamily: "Helvetica, Roboto, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-xaxis-label",
            },
            offsetX: 5,
            offsetY: 5,
          },
        },
      },
      series: [
        {
          name: "Média (%)",
          data: null,
        },
      ],
    };
  },
  computed: {},
  methods: {
    prepareLabels(data) {
      let first = true;
      return data.map((a) => {
        if (first) {
          first = false;
          return a.topic;
        }
        return this.truncateString(a.topic, 4);
      });
    },
    truncateString(str, num) {
      // If the length of str is less than or equal to num
      // just return str--don't truncate it.
      let words = str.split(" ");
      let ret = [];
      let sentence = "";
      let lines = 2;
      if (words.length > 8) lines = 3;
      let middle = words.length / lines;
      let countWordSentence = 0;
      for (let i = 0; i < words.length; i++) {
        sentence += words[i] + " ";
        countWordSentence++;
        if (countWordSentence >= middle) {
          ret.push(sentence.trim());
          sentence = "";
          countWordSentence = 0;
        }
      }
      if (countWordSentence > 0) ret.push(sentence.trim());
      return ret;
    },
  },
};
</script>

<style></style>
